import { render, staticRenderFns } from "./SerialPrint.vue?vue&type=template&id=740b71a0&"
import script from "./SerialPrint.vue?vue&type=script&lang=js&"
export * from "./SerialPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports